import React from "react";
import StatusBadge from "../../UI/statusBadge";
import { formatPrice } from "../../../utils/formatPrice";

const StoreInfo = ({
  name,
  phone,
  section,
  is_active,
  recent_count_order,
  avg_rate,
  currency_factor,
  address,
  email,
  store_setting,
  count_order,
  count_branch,
  owner,
  commission_amount,
}) => {
  const storeInfo = [
    { title: "اسم المتجر", value: name },
    {
      title: "العمولة",
      value: formatPrice(currency_factor, commission_amount),
    },
    { title: "عدد الفروع", value: count_branch },
    { title: "المدينة", value: address },
    { title: "عدد الطلبات", value: count_order },
    { title: "البريد الإلكتروني", value: owner?.email },

    { title: "المالك", value: owner?.full_name },
    { title: "نوع المتجر", value: section?.type },
    { title: "الحالة", value: is_active },
    { title: "رقم الجوال", value: phone },

    { title: "تقييم المتجر", value: `${avg_rate} ⭐` },
    { title: "سعة المطبخ", value: store_setting?.kitchen_capacity },
    {
      title: "متوسط وقت التحضير",
      value: `${store_setting?.avg_prep_time} دقيقة`,
    },
    {
      title: "أقصى وقت للتحضير",
      value: `${store_setting?.max_prep_time} دقيقة`,
    },
    { title: "حد الانشغال", value: store_setting?.busy_threshold },
  ];
  return (
    <div className="row">
      <h5 className="mb-3">معلومات المتجر</h5>
      <div className="col-12">
        <ul className="two-columns">
          {storeInfo.map((item, index) => (
            <li key={index}>
              <h4 className="font14 font700">{item.title}</h4>
              {item.title === "الحالة" ? (
                <StatusBadge status={is_active ? "active" : ""} />
              ) : (
                <p>{item?.value}</p>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default StoreInfo;
